/**
 * PURPOSE: Mostrar uno o dos swatches del catálogo aprobado de uniformes (FTR-0014).
 * RESPONSIBILITIES: Círculos con borde visible también para colores claros; título accesible con el nombre.
 * COLLABORATORS: CompanyUniformsTab.jsx, UniformOptionEditor.jsx, MatchUniformOptionsFields.jsx.
 * ROUTE: winscore/src/admin/AdminCompany/UniformSwatches.jsx
 */
import React from "react";

const SIZES = { sm: "h-3.5 w-3.5", md: "h-5 w-5", lg: "h-7 w-7" };

const UniformSwatches = ({ colors = [], size = "md" }) => (
  <span className="inline-flex shrink-0 items-center -space-x-1" aria-hidden="true">
    {colors.filter(Boolean).map((color) => (
      <span
        key={color.id ?? color.name}
        title={color.name}
        className={`${SIZES[size] || SIZES.md} inline-block rounded-full border border-slate-300 ring-1 ring-white`}
        style={{ backgroundColor: `#${color.hex}` }}
      />
    ))}
  </span>
);

export default UniformSwatches;
